import { useRef, useState } from "react";
import { FaChevronDown } from "react-icons/fa";

import { useOutsideClick } from "src/helpers";

export type Option = {
  id: string;
  label: string;
  value: any;
  show?: boolean;
};

export const IcomDropdown = ({
  id,
  listOptions,
  onChange,
  onOpen,
  onClose,
  selectedOption,
  className,
}: {
  id?: string;
  listOptions: Array<Option>;
  className?: string;
  onChange: (option: Option) => void;
  onOpen?: () => void;
  onClose?: () => void;
  selectedOption: any;
}) => {
  // Get current selected option
  const _selectedOpt = listOptions.find((opt) => opt.value === selectedOption);

  // Create internal state
  const [state, setState] = useState<{
    selectedOption: Option | null;
    showDropdown: boolean;
  }>({
    selectedOption: _selectedOpt || null,
    showDropdown: false,
  });

  const sideRef = useRef<HTMLElement>(null);

  // On click "Avaliar"
  const selectHandler = (option: Option): void => {
    setState((s) => ({ ...s, selectedOption: option, showDropdown: false }));

    return onChange(option);
  };

  // Toggle Dropdown
  const toggleDropdown = (forceStatus?: boolean) => {
    const open = forceStatus != undefined ? forceStatus : !state.showDropdown;

    if (open) onOpen?.();
    else onClose?.();

    setState((s) => ({ ...s, showDropdown: forceStatus ?? !s.showDropdown }));
  };

  useOutsideClick(sideRef, () => toggleDropdown(false));

  return (
    <div className={`icom-dropdown ${className}`}>
      <div ref={sideRef as React.RefObject<HTMLDivElement>} className="flex flex-col relative">
        <button
          id={id}
          type="button"
          onClick={() => toggleDropdown()}
          className="icom-dropdown--input border bg-white border-neutral-gray-200 rounded-lg p-3 flex items-center justify-between"
        >
          {state.selectedOption ? state.selectedOption.label : <span className="text-neutral-gray-300">Selecione</span>}
          <FaChevronDown className="text-neutral-gray-300" />
        </button>

        {state.showDropdown && (
          <div
            className="icom-dropdown--dropdown border bg-white border-neutral-gray-200 rounded-lg py-5 px-3 mt-2 flex flex-col items-start
              absolute top-full overflow-y-auto w-full max-h-[300px] z-10
            "
          >
            {listOptions
              .filter((opt) => opt.show !== false)
              .map((opt) => (
                <button key={opt.id} type="button" onClick={() => selectHandler(opt)} className="w-full rounded-lg text-left text-neutral-gray-500 hover:bg-slate-100 p-3">
                  {opt.label}
                </button>
              ))}

            {!listOptions.length && <span>Nenhuma opção disponível</span>}
          </div>
        )}
      </div>
    </div>
  );
};
